import {
  checkFalseyValue,
  INVALID_RESPONSE_MSG,
  POSTCODE_REGEX,
  VALIDATION_POSTCODE,
} from "utils/validation";
import * as Yup from "yup";

const validation = Yup.object({
  isSecuredPropertySameAsApplicantAddress: Yup.bool()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG),

  addressLine1: Yup.string().when("isSecuredPropertySameAsApplicantAddress", {
    is: (value: any) => checkFalseyValue(value),
    then: () => Yup.string().required(INVALID_RESPONSE_MSG),
    otherwise: () => Yup.string().nullable(),
  }),

  townOrCity: Yup.string().when("isSecuredPropertySameAsApplicantAddress", {
    is: (value: any) => checkFalseyValue(value),
    then: () => Yup.string().required(INVALID_RESPONSE_MSG),
    otherwise: () => Yup.string().nullable(),
  }),

  postcode: Yup.string().when("isSecuredPropertySameAsApplicantAddress", {
    is: (value: any) => checkFalseyValue(value),
    then: () =>
      Yup.string()
        .trim()
        .required(INVALID_RESPONSE_MSG)
        .matches(POSTCODE_REGEX, VALIDATION_POSTCODE),
    otherwise: () => Yup.string().nullable(),
  }),

  propertyType: Yup.string().required(INVALID_RESPONSE_MSG),
}).nullable();

export default validation;
